import { useQuery } from '@tanstack/react-query';

import { trafficSourceTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getTrafficSources: trafficSourceTypes.GetTrafficSources = () => {
  return axios.get(`/traffic-sources`);
};

type QueryFnType = typeof getTrafficSources;

type UseGetTrafficSourcesOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetTrafficSources = ({ config = {} }: UseGetTrafficSourcesOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['traffic-sources'],
    queryFn: () => getTrafficSources(),
  });
};
